import { get } from 'lodash';
import { instance } from './api.service';

export const getLifecycleReport = async (opts = {}) => {
  const resp = await instance({
    url: `/reports/lifecycle`,
    method: 'post',
    credentials: 'include',
    data: opts
  });
  return get(resp, 'data.data', []);
};

// Backwards-compat alias — admin Reports button still uses this name internally.
export const getTimestampReport = getLifecycleReport;